import React from 'react';
import rawToReact from 'Utils/bbcode/RawToReact';

let ForumLinkComponent = (props) => {
	const {title, link} = props.forum;

	let openLink = () => {
		window.open( link );
	};

	return (
		<div className="forum"  onClick={ () => openLink() } >
			<div className="title">
				{ rawToReact(title) }
			</div>
			<div className="link">
				{ link }
			</div>
		</div>
	)
};

export default ForumLinkComponent;


// WEBPACK FOOTER //
// ./src/components/forums/ForumLinkComponent.js